import React, { FC, useState } from 'react'
import Modal from '../common/Modal'

import '../../assets/scss/first_introduction.scss'

interface IntroModalProps {
  isOpen: boolean
  onCloseModal: () => void
}
const MemberMonthlyIntro: FC<IntroModalProps> = (props) => {
  const { isOpen, onCloseModal } = props
  const initialIntro = {
    show: isOpen,
    currentPage: 0,
  }
  const [intro, setIntro] = useState(initialIntro)

  const handleNextIntro = () => {
    setIntro({
      ...intro,
      currentPage: intro.currentPage + 1,
    })
  }

  const handlePrevIntro = () => {
    setIntro({
      ...intro,
      currentPage: intro.currentPage - 1,
    })
  }

  const handleCloseIntro = () => {
    setIntro({
      show: false,
      currentPage: 0,
    })
    onCloseModal()
  }

  const renderIntroModal1 = () => (
    <>
      <h1 className="intro-title">個人データページ(月次・期間選択)の見方</h1>
      <div className="intro-body">
        <div className="intro-description">
          <h3>
            個人データ(月次・期間選択)ではユーザーの１ヶ月の作業内容詳細を確認できます。
          </h3>
          <h3 className="intro-sample">操作量と時間の推移を表すグラフサンプル</h3>
          <img
            alt="member_daily_report_whole"
            src="/static/images/firstIntroduction/member_report/monthly/1.png"
            style={{ border: 'solid 3px #878c9a', borderRadius: '10px', width: '100%', height: '70%' }}
            className="sample-image"
          />
          <h4 className="graph-detail">
            １ヶ月を通しての操作量(水色折れ線グラフ)と作業時間(紺色棒グラフ)の推移を表す複合グラフです。
            <br />
            操作量、作業時間の値だけでなく、作業時間に対する操作量の割合もこのグラフで可視化されます。
          </h4>
        </div>
      </div>
    </>
  )

  const renderIntroModal2 = () => (
    <>
      <h1 className="intro-title">個人データページ(月次・期間選択)の見方</h1>
      <div className="intro-body">
        <div className="intro-description">
          <h3 className="intro-sample">アプリ使用量を表すヒートマップサンプル</h3>
          <img
            alt="member_daily_report_whole"
            src="/static/images/firstIntroduction/member_report/monthly/2.png"
            style={{ border: 'solid 3px #878c9a', borderRadius: '10px', width: '100%', height: '70%' }}
            className="sample-image"
          />
          <h4 className="graph-detail">
            １ヶ月を通してのアプリ使用量の推移を表すヒートマップです。
            <br />
            アプリ使用量が多いほどタイルの色が濃く表示されており、各タイルをホバーするとその日の使用量を確認できます。
            <br />
            グラフ横軸において水色と赤色の数字はそれぞれ土曜日と日曜日の値を示しています。
          </h4>
        </div>
      </div>
    </>
  )

  return (
    <Modal
      show={isOpen}
      modalSize="large"
      wrapperClass=""
      closeCallback={handleCloseIntro}
      closeable
    >
      <div className="introduction">
        { intro.currentPage === 0 && renderIntroModal1() }
        { intro.currentPage === 1 && renderIntroModal2() }
      </div>
      <>
        {
          intro.currentPage !== 0 && (
            <button
              type="button"
              className="button"
              onClick={handlePrevIntro}
            >
              前の説明
            </button>
          )
        }
        {
          intro.currentPage === 1 ? (
            <button
              type="button"
              className="button complete"
              onClick={handleCloseIntro}
            >
              完了
            </button>
          ) : (
            <button
              type="button"
              className="button"
              onClick={handleNextIntro}
            >
              次の説明
            </button>
          )
        }
      </>
    </Modal>
  )
}

export default MemberMonthlyIntro
